import React from 'react';
import BaseLayout from '@/shared/components/layout/BaseLayout';
import { UploadDroneForm } from '@/features/upload-drone/forms/UploadDroneForm';

const UploadDronePage: React.FC = () => {
  return (
    <BaseLayout>
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <UploadDroneForm />
      </div>
    </BaseLayout>
  );
};

export default UploadDronePage;

